import { jsx as _jsx } from "react/jsx-runtime";
import { getLayouts, getLayoutsConfigTable } from './layouts';
import TabelaBase from '../../library/TabelaBase';
export default function TabelaPosicaoConsolidada(props) {
    const { titulo = 'Posição Consolidada', rows, layout = 'default', datas, percentHeaderText } = props;
    const layoutConfigTable = getLayoutsConfigTable()[layout];
    return (_jsx(TabelaBase, { rows: rows, layout: layout, titulo: titulo, layouts: getLayouts(datas, percentHeaderText), height: 400, enhancedTableProps: Object.assign({ noScroll: true, lineBreak: true, headerFixed: true, fontSize: 12 }, layoutConfigTable) }));
}
